import React from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import PageHeader from '../page_header';
import PageHeaderTitle from '../page_header_title';

import './form_header.scss';

const getLinkBackButton = (linkBack, linkText) => {
  const history = useHistory();

  if (linkBack === true) {
    return (
      <Button
        color="link"
        className="align-self-start icon-chevron-left page-header__link"
        role="button"
        onClick={history.goBack}
      >
        {linkText}
      </Button>
    );
  }

  return (
    <Link className="align-self-start icon-chevron-left page-header__link" to={linkBack}>
      {linkText}
    </Link>
  );
};

const getLinkForwardButton = (linkForward, linkText) => (
  <Link className="align-self-end icon-chevron-right page-header__link" to={linkForward}>
    {linkText}
  </Link>
);

const FormHeader = ({ text, linkText, linkBack, linkForward }) => {
  const backButton = linkBack ? getLinkBackButton(linkBack, linkText) : null;
  const forwardButton = linkForward ? getLinkForwardButton(linkForward, linkText) : null;

  return (
    <PageHeader className="form-header__container" paddingBottom="0">
      {backButton}
      {forwardButton}

      {text !== null ? (
        <PageHeaderTitle title={text} />
      ) : (
        <div className="page-header-title p-0 m-0 pb-3 align-self-start" />
      )}
    </PageHeader>
  );
};

FormHeader.propTypes = {
  text: PropTypes.string,
  linkText: PropTypes.string,
  linkBack: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  linkForward: PropTypes.string,
};

FormHeader.defaultProps = {
  text: null,
};

export default FormHeader;
